import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SafeUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import Swal from 'sweetalert2'
import { ProductSubCategoryService } from '../product-subcategory-service';
import { AlertService } from 'src/app/_services/alert.service';

@Component({
  selector: 'app-product-subcategory-add',
  templateUrl: './product-subcategory-add.component.html',
  styleUrls: ['./product-subcategory-add.component.scss']
})
export class ProductSubcategoryAddComponent implements OnInit {

  selectedFile: SafeUrl = 'assets/images/product.png';
  submitted: boolean = false;
  addSubcategoryForm !:FormGroup;
  categoryDropdownList : any[];
  constructor(private router: Router,private formBuilder : FormBuilder,private subCategoryService : ProductSubCategoryService,private alertService : AlertService) { }

  ngOnInit(): void {

    this.addSubcategoryForm = this.formBuilder.group({
      subCategoryImage : ['',Validators.required],
      subCategoryName : ['',Validators.required],
      subCategoryDesc : ['',Validators.required],
      category : [null,Validators.required],
      // status : [null,Validators.required]
    })

    this.subCategoryService.getCategoryDropdown().subscribe((response:any)=>{
      this.categoryDropdownList = response.response.data;
    })
  }

  cancelButton(){
    this.router.navigateByUrl('/productSubcategory/productSubcategoryList')
  }

  removeFile() {
    this.selectedFile = 'assets/images/product.png';
    this.addSubcategoryForm.get('subCategoryImage')?.reset();
  }



  setSubcategoryProfile(profile : any){
    console.log("Choose File Clicked");
    var file = profile.target.files[0];
    if(file.size > 50000){
      console.log("Greater than 50 KB");
      Swal.fire('Icon size cannot be greater than 50 KB','','error');
      return;
    }
    profile.target.value = '';
    this.addSubcategoryForm.get('subCategoryImage')?.setValue(file);
    var reader = new FileReader();
    reader.onloadend = this.handleReaderLoaded.bind(this);
    reader.readAsDataURL(file);

  }

  handleReaderLoaded(e: any) {
    let reader = e.target;
    this.selectedFile = reader.result;
    console.log("Image Data : "+reader.result)
  }


  // Method to validate subcategory name input (alphanumeric, underscore, and spaces allowed)
  onSubcategoryNameKeyPress(event: any): boolean {
    const charCode = event.which || event.keyCode;
    const char = String.fromCharCode(charCode);
    
    // Allow: backspace, delete, tab, escape, enter
    if ([8, 9, 27, 13, 46].indexOf(charCode) !== -1) {
      return true;
    }
    
    // Allow: alphanumeric characters (a-z, A-Z, 0-9), underscore (_), and space
    const pattern = /^[a-zA-Z0-9_ ]$/;
    if (!pattern.test(char)) {
      event.preventDefault();
      return false;
    }
    
    return true;
  }

  // Method to validate subcategory description input (alphanumeric, underscore, and spaces allowed)
  onSubcategoryDescKeyPress(event: any): boolean {
    const charCode = event.which || event.keyCode;
    const char = String.fromCharCode(charCode);
    
    // Allow: backspace, delete, tab, escape, enter
    if ([8, 9, 27, 13, 46].indexOf(charCode) !== -1) {
      return true;
    }
    
    // Allow: alphanumeric characters (a-z, A-Z, 0-9), underscore (_), and space
    const pattern = /^[a-zA-Z0-9_ ]$/;
    if (!pattern.test(char)) {
      event.preventDefault();
      return false;
    }
    
    return true;
  }

  addSubcategory(data:any){
    this.submitted = true;
    if(this.addSubcategoryForm.valid){
      console.log("Valid");
      console.log("Sub Category Image : "+data.subCategoryImage);
      console.log("Sub Category Name : "+data.subCategoryName);
      console.log("Sub Category Description : "+data.subCategoryDesc);
      console.log("Selected Category : "+data.category);
      console.log("Sub Category Status : "+data.status);

      let requestForm = {
        "name": data.subCategoryName,
        "description": data.subCategoryDesc,
        "productCategoryId" : data.category,
        // "status": data.status
      };
      var requestData = new FormData();
      requestData.append("icon",this.addSubcategoryForm.value.subCategoryImage);
      requestData.append("request",JSON.stringify(requestForm));
      console.log(requestData);
      var xhr = new XMLHttpRequest;
      xhr.open('POST', '/', true);
      xhr.send(requestData);
      this.subCategoryService.saveSubCategory(requestData).subscribe((response:any)=>{
        console.log(response);
        if(response.response.status == 200){
          Swal.fire(response.response.message, '', 'success').then((result)=>{
            if (result.isConfirmed) {
              this.router.navigate(['/productSubcategory/productSubcategoryList']);
            } 
          });
        }else{
          Swal.fire(response.response.message, '', 'error');
        }
      })

    }else{
    console.log("Not Valid");
    }
  }

}
